import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from '../../node_modules/classnames/index.js';
import styles from './ButtonGroup.module.scss.js';
import { applyCommonProps } from '../utility/commonProps.js';

var _excluded = ["children", "className"];
/**
 * Button Groups display multiple related actions in a horizontal row to help with arrangement and spacing.
 *
 * - {@link https://livingdesign.walmart.com/components/button-group/ Guidelines}
 * - {@link https://livingdesign.walmart.com/components/button-group/react/ React documentation}
 *
 * ### Content
 *
 * The Button Group accepts Button elements through the `children` prop:
 *
 * ```tsx
 * <ButtonGroup>
 *   <Button>Cancel</Button>
 *   <Button variant="primary">Submit</Button>
 * </ButtonGroup>
 * ```
 */
var ButtonGroup = function ButtonGroup(props) {
  var _applyCommonProps = applyCommonProps(props, ButtonGroup),
    children = _applyCommonProps.children,
    className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.buttonGroup, className),
    role: "list"
  }, rest), React.Children.map(children, function (child, index) {
    var _child$key;
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }
    var childKey = (_child$key = child.key) !== null && _child$key !== void 0 ? _child$key : index;
    return /*#__PURE__*/React.createElement("div", {
      key: childKey,
      role: "listitem"
    }, child);
  }));
};
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup };
